import { render, staticRenderFns } from "./LawTradeFairSubjectForm.vue?vue&type=template&id=d0f19fac&"
import script from "./LawTradeFairSubjectForm.vue?vue&type=script&lang=js&"
export * from "./LawTradeFairSubjectForm.vue?vue&type=script&lang=js&"
import style0 from "./LawTradeFairSubjectForm.vue?vue&type=style&index=0&id=d0f19fac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports